
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
import { ILanguages } from './system/language/LanguageSystem';

export const ES_LANGUAGE_VALUE = 'es';
export const EN_LANGUAGE_VALUE = 'en';
export const LANGUAGE_LS_KEY = 'translation_';

export const saveOnSessionStorageLanguage = (val: string) => {
  sessionStorage.setItem('language', val);
};
export const getSessionStorageLanguage = () => {
  let ret = sessionStorage.getItem('language');
  if (ret === null) {
    var userLang = navigator.language;
    ret = userLang.substring(0, 2);
  }
  return ret;
};

export const loadTranslationsFromS3 = async (languages: ILanguages) => {
  const translations = {};
  const translationsKey = Object.keys(languages).map((key) => `${LANGUAGE_LS_KEY}${key}`);

  try {
    for (const lang in languages) {
      const { file } = languages[lang];
      const res = await axios.get(file);
      translations[`${LANGUAGE_LS_KEY}${lang}`] = JSON.stringify(res.data);
    }

    return { translationsKey, translations };
  } catch (error) {
    console.error('Error loading translations from S3:', error);
    return { translationsKey: [], translations: {} };
  }
}

const loadStoredTranslations = () => {
  const resources = {};
  // Obtener los idiomas disponibles a partir del LANGUAGE_LS_KEY
  const langs = Object.keys(localStorage).filter((key) => key.startsWith(LANGUAGE_LS_KEY)).map((key) => key.replace(LANGUAGE_LS_KEY, ''));
  
  try {
    langs.forEach((lang) => {
    const stored = localStorage.getItem(`${LANGUAGE_LS_KEY}${lang}`);
    if (stored) {
      resources[lang] =JSON.parse(stored) || {};
    }
  });
  } catch (error) {
    console.error('Error loading translations from localStorage:', error);
    for (const lang of langs) {
      localStorage.removeItem(`${LANGUAGE_LS_KEY}${lang}`);
    }
  }
  return resources;
}

const resources = loadStoredTranslations();
var userLang = getSessionStorageLanguage();
userLang = userLang.substring(0, 2);

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: userLang, // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
  
i18n.on('languageChanged', (lng) => {
  saveOnSessionStorageLanguage(lng);
});

export default i18n;
